// Styles here will override Bulma styles
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const styledCodeblockContainer = css`
  max-width: 1170px;

  code,
  pre {
    font-family: 'Cousine-Regular', monospace !important;
  }
`;

export const styledContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  div {
    flex: 40%;
  }

  .styledLineBackground {
    top: 68px !important;
  }

  pre {
    padding: 30px;
    margin: 8px 0;
    overflow: auto;
    border-radius: 0.3em;
    background-color: #1d262f;
    min-height: 265px;
    max-height: 265px;
    overflow-wrap: break-word;
    white-space: initial !important;

    ${media('<desktop')} {
      flex-direction: column-reverse;
      width: auto;
    }
  }

  code {
    white-space: pre-wrap !important;
    word-break: break-all;
  }

  .toolbar-item {
    display: none !important;
  }

  ${media('<desktop')} {
    flex-direction: column;
    .container {
      width: 88%;
    }
  }

  ${media('<tablet')} {
    code,
    pre {
      font-size: 13px;
    }
  }
`;

export const styledCopy = css`
  p {
    font-size: 16px;
  }
`;

export const StyledSideContent = styled.div`
  margin: 80px 64px 0 0;

  div {
    margin-top: 20px;
  }

  h2 {
    font-size: 30px !important;
  }

  ${media('<desktop')} {
    width: 88%;
    text-align: center;
    margin: 40px auto 20px auto;
  }
`;

export const styledHeading = css`
  margin: 64px auto 0 auto;
  text-align: center;
`;

export const styledSubheading = css`
  margin: 20px auto 80px auto !important;
  max-width: 670px;
  text-align: center;
`;

export const StyledCodeblockWrapper = styled.div`
  ${media('<desktop')} {
    width: 100%;
  }
`;

export const StyledCodeblock = styled.div`
  margin-top: ${props => (props.isSingleCodeblock ? '40px' : 0)} !important;
  display: ${props => (props.isSingleCodeblock ? 'block' : 'none')};

  pre {
    padding: 1.25em !important;
    font-size: 15px;
  }

  ${({ active }) => active && `display: inline`}
`;

export const StyledTabContainer = styled.ul`
  list-style: none;
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #e5e8ed;
  margin-bottom: 26px;

  li {
    padding: 20px 16px 20px;
    ${media('<tablet')} {
      padding: 20px 0px;
    }
  }
`;

export const StyledTab = styled.a`
  cursor: pointer;
  margin-bottom: 3px;
  font-family: 'WorkSans-Medium', 'system-ui', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto',
    'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';
  padding: 20px 20px 20px;
  :focus {
    outline: none;
  }
  ${({ active }) => active && `color: #031b4e; border-bottom: 3px solid #0069ff !important`}
`;

// CUSTOM STYLES FOR INSIDE CODEBLOCK
export const customCodeBlockStyles = {
  'hljs-comment': {
    color: '#B0BCDE',
  },
  'hljs-quote': {
    color: '#B0BCDE',
  },
  'hljs-variable': {
    color: '#41CCA2',
  },
  'hljs-template-variable': {
    color: '#41CCA2',
  },
  'hljs-tag': {
    color: '#589DFF',
  },
  'hljs-name': {
    color: '#FF5793',
  },
  'hljs-selector-id': {
    color: '#589DFF',
  },
  'hljs-selector-class': {
    color: '#FF5793',
  },
  'hljs-regexp': {
    color: '#B675EA',
  },
  'hljs-deletion': {
    color: '#589DFF',
  },
  'hljs-number': {
    color: '#B675EA',
  },
  'hljs-built_in': {
    color: '#589DFF',
  },
  'hljs-builtin-name': {
    color: '#589DFF',
  },
  'hljs-literal': {
    color: '#41CCA2',
  },
  'hljs-type': {
    color: '#B0BCDE',
  },
  'hljs-params': {
    color: '#589DFF',
  },
  'hljs-meta': {
    color: '#589DFF',
  },
  'hljs-link': {
    color: '#589DFF',
  },
  'hljs-attribute': {
    color: '#FF5793',
  },
  'hljs-string': {
    color: '#41CCA2',
  },
  'hljs-symbol': {
    color: '#589DFF',
  },
  'hljs-bullet': {
    color: '#41CCA2',
  },
  'hljs-addition': {
    color: '#41CCA2',
  },
  'hljs-title': {
    color: '#589DFF',
  },
  'hljs-section': {
    color: '#589DFF',
  },
  'hljs-keyword': {
    color: '#589DFF',
  },
  'hljs-selector-tag': {
    color: '#589DFF',
  },
  hljs: {
    display: 'block',
    overflowX: 'auto',
    background: '#0C1025',
    color: 'white',
    padding: '0.5em',
  },
  'hljs-emphasis': {
    fontStyle: 'italic',
  },
  'hljs-strong': {
    fontWeight: 'bold',
  },
};
